export default "__VITE_ASSET__5d2c3959__"